'use client';
import { useTranslation } from '@/hook';
import React, { useState } from 'react';
import DownloadAppBottomSheet from '@/components/download-app-bottom-sheet';
import SylndrButton, {
    IButtonStyled,
} from '@/components/shared/Button/button-styled.component';
import Typography from '@/components/shared/typography/typography.component';

export const DownloadApp = ({
    deepLink,
    buttonProps,
    extraClasses,
    text,
}: {
    deepLink?: string | null;
    extraClasses?: string;
    buttonProps?: Partial<IButtonStyled>;
    text?: string;
}) => {
    const { t } = useTranslation();
    const [bottomSheetOpen, setBottomSheetOpen] = useState(false);

    const openBottomSheet = () => {
        setBottomSheetOpen(true);
    };
    const openApp = () => {
        window.location.href = `sylndrapp://${
            deepLink ? deepLink : 'HomeScreen'
        }`;

        setTimeout(() => {
            openBottomSheet();
        }, 500);
    };

    return (
        <>
            <DownloadAppBottomSheet
                open={bottomSheetOpen}
                setOpen={setBottomSheetOpen}
            />
            <SylndrButton
                variant={'outlined'}
                extraCssClasses={`py-2.5 px-4 ${extraClasses}`}
                onClick={openApp}
                {...buttonProps}
            >
                <Typography variant={'body2Medium'}>
                    {text ? text : t('Apply Financing with this EMI')}
                </Typography>
            </SylndrButton>
        </>
    );
};
